<!--
    系统中心-角色权限-编辑
    作用：角色权限的编辑
    组件:Permissions
-->
<template>
  <div class="role_detail">
    <el-form ref="form" :model="roleForm" label-width="110px">
      <el-form-item label="角色名称：">
        <span class="name">{{ name }}</span>
      </el-form-item>
      <el-form-item label="界面权限：">
        <Permissions
          v-model="roleForm.permissions"
          :options="roleStoreBefore.view"
        />
      </el-form-item>
      <el-form-item label="接口权限：">
        <Permissions
          v-model="roleForm.permissions"
          :options="roleStoreBefore.admin"
        />
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import Permissions from "./components/Permissions";
  export default {
    name: "Detail",
    components: {
      Permissions
    },
    data() {
      return {
        id: this.$route.params.id,
        name: this.$route.params.name,
        roleForm: {
          name: '',
          description: '',
          permissions: [],
        },
        roleStoreBefore: {
          view: [],
          admin: []
        },
      }
    },
    created() {
      this.load();
    },
    methods: {
      load() {
        // 加载角色权限树
        this.$http.get('/api/service/operate/permission')
          .then(res => {
            this.roleStoreBefore = res;
          })
          .catch((err) => {
            this.$message.error(err.message);
          })
        // 加载我的角色权限
        this.$http.get(`/api/service/operate/role_permission/${this.id}`)
          .then(res => {
            this.roleForm.permissions = res.permission_ids;
          })
          .catch((err) => {
            this.$message.error(err.message);
          })
      },
      onSubmit() {
        // 修改我的角色权限
        const data = {
          permission_ids: this.roleForm.permissions
        }
        this.$http.put(`/api/service/operate/role_permission/${this.id}`, data)
          .then(res => {
            this.$message.success('保存成功！')
            setTimeout(() => {
              this.$router.back();
            }, 2000)
          })
          .catch((err) => {
            this.$message.error(err.message);
          })
      }
    }
  }
</script>

<style scoped lang="scss">
.name {
  font-size: 14px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/Role/Detail.vue